import Vue from 'vue';
import Component, { createDecorator } from 'vue-class-component';
import { Getter } from 'vuex-class'
import { Products } from '@/api/product';
import { Prop, Watch } from 'vue-property-decorator';

type TableHeader = TableTh[]
type DeletedTableHeader = DeletedTh[]

interface TableTh {
    text?: string,
    value?: string,
    align?: string,
    class?: string,
    sortable?: boolean,
    width?: string
}
interface DeletedTh {
    ind: number
    th: TableTh
}
@Component({
})
export default class BasketListAbstract extends Vue {
    @Getter('basketProducts') products!: Products
    @Prop({ default: true }) showAvailability!: boolean
    @Prop({ default: false }) showCheckbox!: boolean
    headers: TableHeader = [
        { text: '', value: '', class: 'grey lighten-4', sortable: false, width: '80px' },
        { text: '№', class: 'grey lighten-4', value: '', sortable: false },
        { text: 'Артикул', value: 'Артикул', class: 'grey lighten-4', sortable: true },
        { text: 'Наименование', value: 'Наименование', class: 'grey lighten-4', sortable: true },
        { text: 'Цена', value: 'Учетная', align: 'center', class: 'grey lighten-4', sortable: true, width: '120px' },
        { text: 'В наличии', value: 'Наличие', align: 'center', class: 'grey lighten-4', sortable: false },
        { text: 'Кол-во', value: 'quantity', align: 'center', class: 'grey lighten-4', sortable: false},
        { text: 'Кол-во в\nупаковке/коробке', value: 'Артикул', align: 'left', class: 'grey lighten-4', sortable: false},
        { text: 'Итого', value: 'Цена_по_факту', align: 'center', class: 'grey lighten-4', sortable: false, width: '120px' },
        { text: '', value: '', class: 'grey lighten-4', sortable: false, width: '40px' },
    ]
    deletedHeaders: DeletedTableHeader = []

    noResultsText = 'Корзина пуста'
    @Watch('showAvailability') onShowAvailabilityChange(val: boolean, oldVal: boolean) {
        this.spliceTableHeaders('Наличие', val)
    }
    spliceTableHeaders(name: string, flag: boolean) {
        if (!flag)
            this.headers.every((el, ind) => {
                if (el.value === name) {
                    this.headers.splice(ind, 1)
                    return false
                } else return true
            })
        else
            this.deletedHeaders.every((el) => {
                if (el.th.value === name) {
                    this.headers.splice(el.ind, 1, el.th)
                    this.deletedHeaders.splice(el.ind, 1)
                    return false
                } else return true
            })
    }
    get filteredItems() {
        return this.$refs.dataTable && (this.$refs.dataTable as any).filteredItems ? (this.$refs.dataTable as any).filteredItems : [];
    }
    mounted() {
        this.spliceTableHeaders('Наличие', this.showAvailability)
    }
}
